import { RouteObject, type LoaderFunction } from "react-router";
import getResultSetLayer from "../../../../API/result_set_layer";
import TaskmapCrumb from "./TaskmapCrumb";
import Taskmap from "./Taskmap";

const routes: RouteObject = {
  id: "taskmap",
  path: "field/:fieldId/taskmap/:resultSetId",
  loader: getResultSetLayer as LoaderFunction,
  Component: Taskmap,
  handle: {
    Crumb: TaskmapCrumb,
  },
  shouldRevalidate: () => false,
};

export default routes;
